import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import "./Navbar.scss";
import { toast } from "react-toastify";
import newRequest from "../../utils/newRequest";

const Navbar = () => {
  const [active, setActive] = useState(false);
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef(null);

  //get currentUser
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  //scroll navbar
  useEffect(() => {
    const isActive = () => {
      if (window.scrollY > 0) {
        setActive(true);
      } else {
        setActive(false);
      }
    };
    window.addEventListener("scroll", isActive);

    //cleanup function
    return () => {
      window.removeEventListener("scroll", isActive);
    };
  }, []);

  // Close menu if clicking outside
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };


 // To handle click outside
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //logout
  const handleLogout = async (e) => {
    try {
      await newRequest.post("auth/logout");
      localStorage.setItem("currentUser", null);
      navigate("/");
      toast.info(`See you soon ${currentUser?.username} 😎`);
    } catch (err) {
      toast.error(err?.response?.data);
    }
  };

  // handleMenu Toggle
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  // Close menu when clicking on a link
  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={active || pathname !== "/" ? "navbar active" : "navbar"}>
      <div className="navbar-container">
        <div className="navbar-container-logo">
          <Link className="link" to={"/"}>
            <span className="logo-text">Fiverr</span>
          </Link>
          <span className="logo-dot">.</span>
        </div>
        <div className="navbar-container-hamburger" onClick={handleMenuToggle}>
          {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </div>
        <ul
          className={`navbar-container-links ${menuOpen ? "open" : ""}`}
          ref={menuRef}
        >
          <li onClick={handleLinkClick}>Fiverr Buisness</li>
          <li onClick={handleLinkClick}>Explore</li>
          <li onClick={handleLinkClick}>English</li>

          {currentUser ? (
            <div
              className="navbar-container-links-user"
              onClick={() => {
                setOpen(!open);
              }}
            >
              {currentUser && (
                <>
                  <img
                    src={
                      currentUser?.img ? currentUser?.img : "/img/noavatar.jpg"
                    }
                    alt="userpic"
                  />
                  <span>{currentUser?.username}</span>
                </>
              )}
              {open && (
                <div className="user-options" onClick={handleLinkClick}>
                  {currentUser.isSeller && (
                    <>
                      <Link className="link" to={"/mygigs"}>
                        Gigs
                      </Link>
                      <Link className="link" to={"/add"}>
                        Add New Gig
                      </Link>
                    </>
                  )}
                  <Link className="link" to={"/ordres"}>
                    Orders
                  </Link>
                  <Link className="link" to={"/messages"}>
                    Messages
                  </Link>
                  <Link className="link" onClick={handleLogout}>
                    Logout
                  </Link>
                </div>
              )}
            </div>
          ) : (
            <>
              <Link to="/login" className="link" onClick={handleLinkClick}>
                Sign in
              </Link>
              <Link className="link" to="/register">
                <button onClick={handleLinkClick}>Join</button>
              </Link>
            </>
          )}
        </ul>
      </div>
      {(active || pathname !== "/") && (
        <>
          <hr />
          <div className="navbar-menu">
            <span>Graphics & Design</span>
            <span>Video & Animation</span>
            <span>Writing & Translation</span>
            <span>AI Services</span>
            <span>Digital Marketing</span>
            <span>Music & Audio</span>
            <span>Programming & Tech</span>
            <span>Business</span>
            <span>Lifestyle</span>
          </div>
          <hr />
        </>
      )}
    </nav>
  );
};

export default Navbar;
